import { render, staticRenderFns } from "./BasesList.vue?vue&type=template&id=fe487484&"
import script from "./BasesList.vue?vue&type=script&lang=js&"
export * from "./BasesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports